import gql from 'graphql-tag';

export const updateNotifications = gql`
  mutation updateNotifications($notifications: [NotificationInput!]!) {
    updateNotifications(notifications: $notifications) {
      id
    }
  }
`;
